<template>
  <div id="monthlyCalendar">
    <table border="0" cellspacing="0" cellpadding="0" class="schedule-calendar" v-if="calendar !== null && selectedDay !== null">
      <thead class="thead-default">
        <tr>
          <th colspan="7" valign="top" :class="{'title': true, 'is-selected': (typeof (selectedDay) === 'object') &&
            (selectedDay.monthId === calendar.monthId)}">
            {{calendar.title}}
          </th>
        </tr>
        <tr class="days">
          <th
            v-for="item in calendarOptions.days"
            :key="item.name"
            valign="top"
            :class="{
              'days': true, 'is-selected': (typeof (selectedDay) === 'object')
              && selectedDay.day === item.name
              && selectedDay.monthId === calendar.monthId
            }"
          >
            {{ item.text }}
          </th>
        </tr>
      </thead>

      <tbody class="tbody-default">
        <tr v-for="(item, indx) in calendar.body" :key="indx">
          <td valign="top" v-for="(data, indx) in item" :key="indx" :class="{'day': true, 'is-visible': data.isVisible}">
            <div @click="handleDaySelection(data)"
              :class="{'text-label': true, 'is-selected': (typeof (selectedDay) === 'object') && (selectedDay.fullDate === data.fullDate)}">
              {{data.date}}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" src="./monthly-calendar.scss"></style>
<script src="./monthly-calendar.js"></script>
